import { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import { useLocation, useNavigate } from "react-router-dom";
import SoftBox from "components/SoftBox";
import CircularProgress from "@mui/material/CircularProgress";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Footer from "examples/Footer";
import { Card, Typography } from "@mui/material";
import api from "api/api";
import user from "assets/images/illustrations/user.png";
import { ApiResponse } from "model/apiResponseModel";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { ProjectsList } from "model/projectListModel";
import { convertSecondsToHoursInnerCompleted } from "helpers/logMessages";
import { ReactComponent as GraphIcon } from "assets/images/graphicon.svg";
import { ReactComponent as Diamonds } from "assets/images/diamonds.svg";
import { ReactComponent as BarIcon } from "assets/images/bar.svg";
import { formatNumber } from "helpers/logMessages";
import SoftTypography from "components/SoftTypography";
import EditIcon from "@mui/icons-material/Edit";
import { Outlet } from "react-router-dom";
import SoftButton from "components/SoftButton";
import ConfirmDialog from "layouts/leaderboard/components/ConfirmDialog";

function ProjectDetail() {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [projectStatus, setProjectStatus] = useState("");
  const [totalDuration, setTotalDuration] = useState(0);
  const [design, setDesign] = useState("");
  const [artist, setArtist] = useState("");
  const [price, setPrice] = useState("");
  const [currencyCode, setCurrencyCode] = useState("");
  const [canvasWidth, setCanvasWidth] = useState(0);
  const [canvasHeight, setCanvasHeight] = useState(0);
  const [abs, setAbs] = useState(0);
  const [glow, setGlow] = useState(0);
  const [crystal, setCrystal] = useState(0);
  const [dreamerDust, setDreamerDust] = useState(0);
  const [noOfColors, setNoOfColors] = useState(0);
  const [diamondType, setDiamondType] = useState("");
  const [totalAmountDiamonds, setTotalAmountDiamonds] = useState(0);
  const [projectPic, setProjectPic] = useState("");
  const [brand, setBrand] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const [isAdminVerified, setIsAdminVerified] = useState(false);
  const [canvasStartImage, setCanvasStartImage] = useState("");
  const [canvasCompleteImage, setCanvasCompleteImage] = useState("");
  const [tags, setTags] = useState([]);
  const [submitProject, setSubmitProject] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [verificationStatus, setVerificationStatus] = useState("");
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const projectId = queryParams.get("projectId");
  const navigate = useNavigate();
  const isEditMode = location.pathname.includes("/edit");
  const [openEdit, setOpenEdit] = useState(false);
  const [editForm, setEditForm] = useState({
    name: "",
    email: "",
    design: "",
    artist: "",
    price: "",
  });


  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    isLoading: false,
    type: null,
  });

  useEffect(() => {
    const loginData = JSON.parse(
      localStorage.getItem("loginData") || sessionStorage.getItem("loginData")
    );
    if (!loginData) {
      navigate("/authentication/sign-in");
    } else {
      fetchProjectDetail();
    }
  }, [projectId, location.state?.refresh]);

  const fetchProjectDetail = async () => {
    try {
      const projectData = { projectId: projectId };
      const response = await api.getProjectsDetail(projectData);
      const apiResponse = new ApiResponse(response.status, response.message);

      if (apiResponse.status === 1) {
        const projectDetail = new ProjectsList(response.data);
        setEmail(projectDetail.email);
        setName(projectDetail.name);
        setProjectPic(projectDetail.image[0]);
        setProjectStatus(projectDetail.project_status);
        setTotalDuration(projectDetail.totalDuration);
        setDesign(projectDetail.design);
        setArtist(projectDetail.artist);
        setPrice(projectDetail.price);
        setCanvasHeight(projectDetail.canvas_height);
        setCanvasWidth(projectDetail.canvas_width);
        setCurrencyCode(projectDetail.currency_code);
        setAbs(projectDetail.abs);
        setGlow(projectDetail.glow);
        setDreamerDust(projectDetail.dreamerDust);
        setCrystal(projectDetail.crystal);
        setTotalAmountDiamonds(projectDetail.total_amount_diamonds);
        setDiamondType(projectDetail.diamond_type);
        setNoOfColors(projectDetail.no_of_color);
        setBrand(projectDetail.brand);
        setCountryCode(projectDetail.country_code);
        setIsAdminVerified(projectDetail.isAdminVerified);
        setCanvasStartImage(projectDetail.canvas_start_image);
        setCanvasCompleteImage(projectDetail.canvas_complete_image);
        setTags(projectDetail.tags);
        setVerificationStatus(projectDetail.verification_status);
        setSubmitProject(projectDetail.submit_project);
      } else {
        alert(apiResponse.message);
      }
    } catch (error) {
      console.error("Error fetching project detail:", error);
    } finally {
      setIsLoading(false);
    }
  };


  const deleteProject = () => {
    // setIsDeletionLoading(true)
    setConfirmDialog({
      isOpen: true,
      isLoading: false,
    });
  };

  const handleCloseDialog = () => {
    setConfirmDialog((prev) => ({ ...prev, isOpen: false }));
  };

   const handleConfirmDialog = async () => {
      try {
        setConfirmDialog((prev) => ({ ...prev, isLoading: true }));

        const data = { 
          project_id: projectId
        };
        let response = await api.deleteProject(data);
        const apiResponse = new ApiResponse(response.status, response.message);
  
        if (apiResponse.status === 1) {
          alert(apiResponse.message);
          window.location.href = '/projects';
        } else {
          alert(apiResponse.message);
        }

      } catch (error) {
        console.error("Error deleting user:", error);
      } finally {
        setConfirmDialog((prev) => ({ ...prev, isOpen: false, isLoading: false }));
      }
    };

  const handleEditOpen = () => {
    navigate(`/project-detail/edit?projectId=${projectId}`);
  };

  const handleEditClose = () => setOpenEdit(false);

  const handleEditChange = (e) => {
    setEditForm({
      ...editForm,
      [e.target.name]: e.target.value,
    });
  };

  const handleEditSubmit = async () => {
    try {
      // Dummy API call for now
      console.log("Submitting edited data:", editForm);
      // Update local state
      setName(editForm.name);
      setEmail(editForm.email);
      setDesign(editForm.design);
      setArtist(editForm.artist);
      setPrice(editForm.price);
      handleEditClose();
    } catch (error) {
      console.error("Error updating project:", error);
    }
  };

  const handleVerification = async (isVerified) => {
    try {
      const projectData = {
        project_id: projectId,
        isVerified: isVerified,
      };
      
      const response = await api.verifyProjectForLeaderboard(projectData);
      const apiResponse = new ApiResponse(response.status, response.message);

      if (apiResponse.status === 1) {
        // Refetch project details to update the UI
        await fetchProjectDetail();
      } else {
        alert(apiResponse.message);
      }
    } catch (error) {
      console.error("Error updating verification status:", error);
      alert("Failed to update verification status");
    }
  };
  

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <ConfirmDialog
              isOpen={confirmDialog.isOpen}
              handleClose={handleCloseDialog}
              handleConfirm={handleConfirmDialog}
              isLoading={confirmDialog.isLoading}
              title={
                 "Are you sure you want to delete this project permanently?"
              }
              actionText={"Yes, Delete"}
            />

      {isLoading ? (
        <SoftBox display="flex" justifyContent="center" alignItems="center" height="100vh">
          <CircularProgress />
        </SoftBox>
      ) : (
        <>
          {!isEditMode ? (
            <SoftBox mb={3}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  
                  <Card
                    sx={{
                      padding: 3,
                      backgroundColor: "#f9f9f9",
                      borderRadius: "8px",
                      marginBottom: 2,
                    }}
                  >
                     <SoftButton 
                    sx={{ cursor: "pointer", userSelect: "none", ml: "auto" }} 
                    variant="contained" 
                    size="medium" 
                    color="error" 
                    onClick={deleteProject}
                  >
                    Delete Project
                  </SoftButton>
                    <SoftTypography variant="h6" sx={{ paddingTop: 2 }} fontWeight="regular">
                      <b>Name:</b> {name}
                    </SoftTypography>
                    <SoftTypography variant="h6" sx={{ paddingTop: 2 }} fontWeight="regular">
                      <b>Email:</b> {email}
                    </SoftTypography>
                  </Card>
                </Grid>

                {/* Left Section: Project Image and Status */}
                <Grid item xs={12} lg={7}>
                  <Card sx={{ padding: 3, backgroundColor: "#f9f9f9", borderRadius: "8px" }}>
                 
                    <EditIcon
                      sx={{
                        position: "absolute",
                        right: "20px",
                        top: "20px",
                        cursor: "pointer",
                        color: "info.main",
                      }}
                      onClick={handleEditOpen}
                    />
                    <SoftTypography variant="h6" sx={{ paddingTop: 2 }} fontWeight="regular">
                      <b>Brand:</b> {brand}
                    </SoftTypography>
                    <SoftTypography variant="h6" sx={{ paddingTop: 2 }} fontWeight="regular">
                      <b>Design:</b> {design}
                    </SoftTypography>
                    <SoftTypography variant="h6" sx={{ paddingTop: 2 }} fontWeight="regular">
                      <b>Artist:</b> © {artist}
                    </SoftTypography>
                    <SoftTypography variant="h6" sx={{ paddingTop: 2 }} fontWeight="regular">
                      <b>Price:</b>{" "}
                      <span style={{ color: "#ea0606" }}>
                        {currencyCode} {price}
                      </span>
                    </SoftTypography>
                    {/* <SoftTypography variant="h6" sx={{ paddingTop: 2 }} fontWeight="regular">
                    <b>Admin Verification:</b>{" "}
                    <span
                      className="projectbadge"
                      style={{
                        padding: "4px",
                        color: "#fff",
                        borderRadius: "6px",
                        fontWeight: 600,
                        backgroundColor: isAdminVerified ? "green" : "orange",
                      }}
                    >
                      {isAdminVerified === true ? "Verified" : "Not Verified"}
                    </span>
                  </SoftTypography> */}
                    <SoftTypography variant="h6" sx={{ paddingTop: 2 }} fontWeight="regular">
                      <b>Country:</b> {countryCode ? countryCode : "N/A"}
                    </SoftTypography>
                    <SoftTypography variant="h6" sx={{ paddingTop: 2 }} fontWeight="regular">
                      <b>Project Status:</b>{" "}
                      <span
                        className="projectbadge"
                        style={{
                          padding: "4px",
                          color: "#fff",
                          borderRadius: "6px",
                          fontWeight: 600,
                          backgroundColor: projectStatus === "completed" ? "green" : "orange",
                        }}
                      >
                        {projectStatus === "not_started"
                          ? "Not Started"
                          : projectStatus === "completed"
                          ? "Completed"
                          : "In Progress"}
                      </span>
                    </SoftTypography>
                    <SoftTypography variant="h6" sx={{ paddingTop: 2 }} fontWeight="regular">
                      <b>Logged Time:</b> {convertSecondsToHoursInnerCompleted(totalDuration)}
                    </SoftTypography>
                    {/* Dreamer Designs Card */}
                    {/* <Card sx={{ marginTop: 3, padding: 3, backgroundColor: "#e9f0ff", borderRadius: 2 }}> */}
                    {/* <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                      Dreamer Designs
                    </Typography> */}
                    <SoftTypography variant="h6" sx={{ paddingTop: 2 }} fontWeight="regular">
                      <GraphIcon style={{ width: "20px", height: "15px" }} />
                      <b> Size:</b> {canvasWidth} x {canvasHeight} cm
                    </SoftTypography>
                    <SoftTypography variant="h6" sx={{ paddingTop: 2 }} fontWeight="regular">
                      <Diamonds sx={{ marginRight: 1 }} />
                      <b> Diamonds:</b> {diamondType} with {noOfColors} colors
                      {abs > 0 && `, ${abs} AB’s`}
                      {glow > 0 && `, ${glow} glow`}
                      {crystal > 0 && `, ${crystal} crystal drills`}
                      {dreamerDust > 0 && ` and ${dreamerDust} Dreamer Dust drills`}
                    </SoftTypography>
                   <SoftTypography variant="h6" sx={{ paddingTop: 2 }} fontWeight="regular">
                      <BarIcon sx={{ marginRight: 1 }} />
                      {totalAmountDiamonds <= 15000 ? (
                        <b> Beginner Level</b>
                      ) : totalAmountDiamonds <= 38400 ? (
                        <b> Intermediate Level</b>
                      ) : (
                        <b> Pro Level</b>
                      )}
                      &nbsp;with {formatNumber(totalAmountDiamonds)} diamonds
                    </SoftTypography>
                    {/* </Card> */}
                  </Card>
                </Grid>
                <Grid item xs={12} lg={5}>
                  <Card sx={{ padding: 2, textAlign: "center" }}>
                    <SoftBox
                      component="img"
                      src={projectPic === "" ? user : projectPic}
                      alt="Project"
                      width="100%"
                      height="auto"
                      borderRadius="8px"
                    />
                  </Card>
                </Grid>
                {submitProject && (
                <Grid item xs={12}>
                  <Card sx={{ padding: 3, backgroundColor: "#f9f9f9", borderRadius: "8px" }}>
                    <SoftTypography variant="h6" sx={{ marginBottom: 3 }} fontWeight="regular">
                      <b>Verification Status:</b>{" "}
                      <span
                        className="projectbadge"
                        style={{
                          padding: "4px",
                          color: "#fff",
                          borderRadius: "6px",
                          fontWeight: 500,
                          backgroundColor: verificationStatus === "approved" ? "green" : "orange",
                        }}
                      >
                        {verificationStatus.toLocaleUpperCase()}
                      </span>
                    </SoftTypography>

                    <Grid container spacing={3}>
                      {/* Start Image Section */}
                      <Grid item xs={12} md={6}>
                        <SoftTypography variant="h6" sx={{ marginBottom: 2 }} fontWeight="regular" align="center">
                          <b>Canvas Start</b>
                        </SoftTypography>
                        {canvasStartImage ? (
                          <SoftBox
                            component="img"
                            src={canvasStartImage}
                            alt="Start Image"
                            width="80%"
                            height="400px"
                            sx={{
                              objectFit: "cover",
                              cursor: "pointer",
                              display: "block",
                              margin: "0 auto",
                            }}
                            borderRadius="8px"
                            onClick={() => window.open(canvasStartImage, "_blank")}
                          />
                        ) : (
                          <SoftBox
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            sx={{
                              height: 400,
                              width: "80%",
                              backgroundColor: "#f5f5f5",
                              borderRadius: "8px",
                              border: "2px dashed #ddd",
                              margin: "0 auto",
                            }}
                          >
                            <SoftTypography variant="body1" color="text.secondary">
                              Canvas Start Not Available
                            </SoftTypography>
                          </SoftBox>
                        )}
                      </Grid>

                      {/* Complete Image Section */}
                      <Grid item xs={12} md={6}>
                        <SoftTypography variant="h6" sx={{ marginBottom: 2 }} fontWeight="regular" align="center">
                          <b>Canvas Finish</b>
                        </SoftTypography>
                        {canvasCompleteImage ? (
                          <SoftBox
                            component="img"
                            src={canvasCompleteImage}
                            alt="Complete Image"
                            width="80%"
                            height="400px"
                            sx={{
                              objectFit: "cover",
                              cursor: "pointer",
                              display: "block",
                              margin: "0 auto",
                            }}
                            borderRadius="8px"
                            onClick={() => window.open(canvasCompleteImage, "_blank")}
                          />
                        ) : (
                          <SoftBox
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            sx={{
                              height: 400,
                              width: "80%",
                              backgroundColor: "#f5f5f5",
                              borderRadius: "8px",
                              border: "2px dashed #ddd",
                              margin: "0 auto",
                            }}
                          >
                            <SoftTypography variant="body1" color="text.secondary">
                              Canvas Finish Not Available
                            </SoftTypography>
                          </SoftBox>
                        )}
                      </Grid>
                    </Grid>

                    {/* Verification Action Section */}
                    <SoftBox sx={{ marginTop: 5, textAlign: "center" }}>
                      <SoftTypography variant="h6" fontWeight="regular" sx={{ marginBottom: 2 }}>
                        {verificationStatus === "pending" 
                          ? "Would you like to verify or reject this project?"
                          : verificationStatus === "approved"
                          ? "Would you like to reject this project?"
                          : "Would you like to verify this project?"}
                      </SoftTypography>
                      <SoftBox display="flex" justifyContent="center" gap={2}>
                        {(verificationStatus === "pending" || verificationStatus === "rejected") && (
                          <SoftButton
                            variant="contained"
                            color="success"
                            onClick={() => handleVerification(true)}
                            sx={{
                              minWidth: 120,
                              backgroundColor: "green !important",
                              "&:hover": { backgroundColor: "green !important" },
                            }}
                          >
                            Verify
                          </SoftButton>
                        )}
                        {(verificationStatus === "pending" || verificationStatus === "approved") && (
                          <SoftButton
                            variant="contained"
                            color="error"
                            onClick={() => handleVerification(false)}
                            sx={{ minWidth: 120 }}
                          >
                            Reject
                          </SoftButton>
                        )}
                      </SoftBox>
                    </SoftBox>
                  </Card>
                </Grid>
                )}
              </Grid>
            </SoftBox>
          ) : (
            <Outlet context={{ projectId, fetchProjectDetail }} />
          )}
        </>
      )}
      <Footer />
    </DashboardLayout>
  );
}

export default ProjectDetail;
